module.exports = __webpack_public_path__ + "static/media/wizualizacja-1.05c5bd7f.png";